import { useLocalSearchParams } from 'expo-router';

import { JoinScreen } from '@/components/JoinScreen';

export default function JoinTemplateScreen() {
  const { token } = useLocalSearchParams<{ token: string }>();
  return <JoinScreen token={token} />;
}
